import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@pella/sash-framework';
import { CTA } from '../../../';
import { isValidArray } from '../../../utilities/validations';

const QuizCard = ({ data, className }) => (
	<div className={`quizCard flex h-full flex-col justify-center bg-white p-6 text-center ${className || ''}`}>
		{data.card?.[0]?.material_icon && (
			<div className='quizCard-iconWrapper mx-auto mb-5 flex h-16 w-16 flex-col items-center justify-center rounded-full bg-primary md:h-20 md:w-20'>
				<Icon
					name={data.card[0].material_icon}
					className='quizCard-icon !text-[40px] md:!text-[55px]'
				/>
			</div>
		)}

		{data.card?.[0]?.heading && (
			<div
				className='quizCard-heading text-xl font-bold'
				dangerouslySetInnerHTML={{ __html: data.card[0].heading }}
			/>
		)}

		{data.card?.[0]?.description && (
			<div
				className='quizCard-description mt-3 text-sm'
				dangerouslySetInnerHTML={{ __html: data.card[0].description }}
			/>
		)}

		{isValidArray(data.card?.[0]?.ctas) && (
			<CTA
				data={data.card[0].ctas[0]}
				className='quizCard-cta mt-5'
			/>
		)}
	</div>
);

QuizCard.propTypes = {
	data: PropTypes.object.isRequired,
	className: PropTypes.string,
};

export default QuizCard;
